import React from 'react';
import type { Level } from '@/lib/mockData';
import type { Language } from '@/lib/i18n';

interface Props {
  level: Level;
  language: Language;
}

export default function LevelProgressBar({ level, language }: Props) {
  return (
    <div className="flex items-center gap-3">
      <span className="text-lg w-6 flex-shrink-0">{level.icon}</span>
      <div className="flex-1 min-w-0">
        <div className="flex items-center justify-between mb-1">
          <span className="text-xs font-500 text-foreground truncate">{level.title[language]}</span>
          <span className="text-xs font-600 text-muted-foreground ml-2 flex-shrink-0">
            {level.completionPercent}%
          </span>
        </div>
        <div className="h-1.5 bg-muted rounded-full overflow-hidden">
          <div
            className="h-full rounded-full transition-all duration-500"
            style={{
              width: `${level.completionPercent}%`,
              backgroundColor: level.color,
            }}
          />
        </div>
      </div>
    </div>
  );
}